module.exports = __webpack_public_path__ + "assets/img/guide-1.ee9a78e6.png";